import { render, staticRenderFns } from "./MenuStockSetting.vue?vue&type=template&id=2560cb0d&scoped=true"
var script = {}
import style0 from "./MenuStockSetting.vue?vue&type=style&index=0&id=2560cb0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2560cb0d",
  null
  
)

export default component.exports